import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=4bb95fdb"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports